import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { proposalApi } from '@modules/proposals/api';
import queryClient from '@app/queryClient';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

const useDuplicateProposal = () => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['duplicateProposal'],
    mutationFn: ({ external_id }: { external_id: string }) =>
      proposalApi.duplicateProposal(external_id),
    onMutate: ({ external_id }) => {
      trackAmplitudeEvent(
        USER_EVENTS.PROPOSAL.PROPOSAL_DUPLICATION_ATTEMPTED,
        { useContext: true, proposal_id: external_id }
      );
    },
    onSuccess: (_, { external_id }) => {
      trackAmplitudeEvent(
        USER_EVENTS.PROPOSAL.PROPOSAL_DUPLICATION_COMPLETED,
        { useContext: true, proposal_id: external_id }
      );
      queryClient.refetchQueries({ queryKey: ['proposalsList'] });
      toast('info', { message: 'Proposal duplicated' });
    },
    onError: (e) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_DUPLICATION_FAILED, {
        useContext: true,
        error_message: e.message,
      });
      toast('error', { message: e.message });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useDuplicateProposal;
